import * as React from 'react';
export const SvgFiletypeAutocad = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#00aeff' }),
        React.createElement("path", { d: 'M10.602 12.548l1.367-.122L7.435 5H6.082l-.513 8 1.54-.138.042-1.587 2.646-.114zm-3.416-2.467L7.271 6.9l1.807 3.115z', fill: '#fff' }),
        React.createElement("path", { d: 'M14 3h-3V0z', fill: '#0079b2' })));
};
export default SvgFiletypeAutocad;
